import router from '../router.js'
export const getBaseUrl = () => {
    let baseURL = ''
    if(process.env.VUE_APP_GRALIC === 'development') { //https://wisdom-fat.doutuimao.net
      baseURL = 'https://wisdom-fat.doutuimao.net'
    } else if(process.env.VUE_APP_GRALIC === 'sandbox') {
      baseURL = 'http://feature-dev-wisdom.fat.doutuimao.net'
    } else if(process.env.VUE_APP_GRALIC === 'test') {
      baseURL = 'http://wisdom.fat.doutuimao.net'
    } 
	else {
      // baseURL = 'https://wisdom.doutuimao.net' // 正式环境后端域名1
      baseURL = 'https://wisdom.doubaozhidao.com' // 正式环境后端域名2
    }
    return baseURL
  }
  const staticPathTitle = { // 最后一个顺序不可改
    '/ks/': {
      label: '快手',
      value: 2,
      path: '/ks/'
    },
    '/wx/': {
      label: '微信',
      value: 3,
      path: '/wx/'
    },
    '/sph/': {
      label: '视频号',
      value: 4,
      path: '/sph/'
    },
    '/xhs/': {
      label: '小红书',
      value: 5,
      path: '/xhs/'
    },
    '/dd/': {
      label: '抖店',
      value: 6,
      path: '/dd/'
    },
    '/': {
      label: '抖音',
      value: 1,
      path: '/'
    }
  }
  export const getPlatInfo = (data) => {
	  let plat = {}
	  const platList = [
		  {
        label: '快手',
        value: 2,
        path: '/ks/'
		  },
		  {
        label: '微信',
        value: 3,
        path: '/wx/'
		  },
      {
        label: '视频号',
        value: 4,
        path: '/sph/'
      },
      {
        label: '小红书',
        value: 5,
        path: '/xhs/'
      },
      {
        label: '抖店',
        value: 6,
        path: '/dd/'
      },
		  {
        label: '抖音',
        value: 1,
        path: '/'
		  }
	  ]
	  if(data) {
		  plat = platList.find((items)=> items.path == data)
		  return plat
	  } else {
		for (const item of platList) {
		  if(location.pathname.includes(item.path)) {
		    plat = platList.find((items)=> items.path == item.path)
		    return plat
		  }
		}   
	  }
   }
  
  let staticPaths = ''
  for (const key in staticPathTitle) {
    if(location.pathname.includes(key)) {
      staticPaths = staticPathTitle[key].path
      break;
    }
  }
  export const staticPath = staticPaths
  export default staticPathTitle
  export const limitPrice = (start,value) => {
    let obj = {
      '/': [start, 10000],
      '/dd/': [start, 10000],
      '/ks/': [start, 10000],
      '/wx/': [start, 10000],
      '/sph/': [start, 10000],
      '/xhs/': [start, 10000]
    }
    let list = obj[staticPath]
    let flag = true
    if(staticPath == '/'){
    	if((list[0]>0?value*100 >= list[0] * 100:value*100 > list[0] * 100) && value*100 < list[1]* 100) {
    	  flag = false
    	}
    } else {
    	if((list[0]>0?value*100 >= list[0] * 100:value*100 > list[0] * 100) && value*100 < list[1]* 100) {
    	  flag = false
    	}
    }
    return {
      flag,
      value: list.join('~'),
	  limit: list
    }
  }
  export const getAliFileUploadUrl = () => {
    if(process.env.VUE_APP_GRALIC === 'production') {
      return {
        //2025-07-04 18:33 https://file-hs.us0.me 换为 https://file-hs.doubaozhidao.com
        requestUrl: 'https://file-hs.doubaozhidao.com',
        region: 'oss-cn-beijing',
        projectFirst: '',
        img: {
          domain: 'http://img-dbzd.doubaozhidao.com',
          bucket: 'img-dbzd',
          projectSecond: '',
          zip: '?x-oss-process=image/quality,q_50/format,'
        },
        video: {
          domain: 'https://video-dbzd.doubaozhidao.com',
          bucket: 'video-dbzd',
          projectSecond: '',
          minTimes: 60
        },
        audio: {
          domain: 'https://audio-dbzd.doubaozhidao.com',
          bucket: 'audio-dbzd',
          projectSecond: '',
          minTimes: 60
        },
        other: {
          domain: 'http://img-dbzd.doubaozhidao.com',
          bucket: 'img-dbzd',
          projectSecond: '',
        },
      }
    } else {
      return {
        requestUrl: 'https://file-hs.doubaozhidao.com',
        region: 'oss-cn-beijing',
        projectFirst: 'dbzd/',
        img: {
          domain: 'https://fat-all-o.doutuimao.net',
          bucket: 'fat-all-o',
          projectSecond: 'img/',
          zip: '?x-oss-process=image/quality,q_50/format,'
        },
        video: {
          domain: 'https://fat-all-o.doutuimao.net',
          bucket: 'fat-all-o',
          projectSecond: 'video/',
          minTimes: 60
        },
        audio: {
          domain: 'https://fat-all-o.doutuimao.net',
          bucket: 'fat-all-o',
          projectSecond: 'audio/',
          minTimes: 60
        },
        other: {
          domain: 'https://fat-all-o.doutuimao.net',
          bucket: 'fat-all-o',
          projectSecond: 'other/',
        }
      }
    }
  }
